/**
 * Title styling for an entity's name Input — the Project title in the issue
 * summary, and the Account and Contact names in their profile headers and
 * create dialogs. ONE class, so every detail surface renames in place with
 * the same grammar.
 *
 * `unstyled` only strips the wrapper's chrome, so the height and horizontal
 * padding the control part carries are reset through its `data-slot` — part
 * targeting is the sanctioned composition seam. Hover wears the ghost hover
 * wash — the rename affordance — and while editing the wash drops for a
 * neutral hairline border, so the active title reads as a field, not a hovered
 * row. The wrapper is made `flex` and carries the 10px/8px padding itself:
 * unstyled, it is display:inline, and inline padding on it (or padding on the
 * inner input) paints outside the line box, so the wash would never grow with
 * it. The padding plus the always-reserved 1px border is bled back out with
 * negative margins (11px/9px), so the title text stays flush with the content
 * around it in every state. At rest a name wider than the column ellipsizes
 * like every other one-line name (a native input clips by default, so a long
 * name on a phone ended mid-word); on focus the browser drops the ellipsis
 * and scrolls the caret, which is the editing behaviour. An `aria-invalid`
 * input (a required title left empty) turns the border destructive.
 */
export const TITLE_INPUT =
  "flex text-2xl font-semibold rounded-md border border-transparent px-2.5 py-2 -mx-[11px] -my-[9px] transition-colors not-focus-within:hover:bg-wash-hover focus-within:border-(--border-strong) has-aria-invalid:border-destructive/64 [&_[data-slot=input]]:h-auto [&_[data-slot=input]]:px-0 [&_[data-slot=input]]:py-0 [&_[data-slot=input]]:leading-snug [&_[data-slot=input]]:text-ellipsis";
